export enum OldFeatureFlag {
    allowsAddPhotoFromLibrary = "allowsAddPhotoFromLibrary",
    allowsLevel2Chat = "allowsLevel2Chat",
    allowsLevel3Chat = "allowsLevel3Chat",
    allowsMaterialsInTickets = "allowsMaterialsInTickets",
    allowsWebLogin = "allowsWebLogin",
    buildingsTitle = "buildingsTitle",
    hasPresenteeismTable = "hasPresenteeismTable",
    hasWhitelistColaborators = "hasWhitelistColaborators",
    hasFrequencyTable = "hasFrequencyTable",
}

export enum FeatureFlag {
    PresenteeismDuplicatedLocationCheck = "PresenteeismDuplicatedLocationCheck",
    /** @deprecated shiftv1 is deprecated, use shiftv2 FF */
    PresenteeismShiftStats = "PresenteeismShiftStats",
    /** @deprecated shiftv1 is deprecated, use shiftv2 FF */
    PresenteeismShiftAlarms = "PresenteeismShiftAlarms",
    /** @description not completed */
    PresenteeismOfflineType = "PresenteeismOfflineType",
    WhatsappDebouncer = "WhatsappDebouncer",
    WebDashboardMap = "WebDashboardMap",
    TypeFormPDFGeneration = "TypeFormPDFGeneration",
    QontactPointCreationWeb = "QontactPointCreationWeb",
    AutomaticClosingMessages = "AutomaticClosingMessages",
    RFIPresenteeism = "RFIPresenteeism",
    UserShiftAssignment = "UserShiftAssignment",
    MailSegmentation = "MailSegmentation",
    NovedadesWeb = "NovedadesWeb",
    NovedadesExportWeb = "NovedadesExportWeb",
    RequestsWeb = "RequestsWeb",
    PresenteeismAutoClosingTicket = "PresenteeismAutoClosingTicket",
    DashboardNotification = "DashboardNotification",
    PresenteeismMySQLConsistencyCheck = "PresenteeismMySQLConsistencyCheck",
    PresenteeismCheckoutControl = "PresenteeismCheckoutControl",
    PresenteeismCheckoutReminder = "PresenteeismCheckoutReminder",
    PresenteeismShiftsV2 = "PresenteeismShiftsV2",
    PresenteeismUserDedicatedShiftsV2 = "PresenteeismUserDedicatedShiftsV2",
    MetabaseWebReports = "MetabaseWebReports",
    AlertsWeb = "AlertsWeb",
    LiteVersion = "LiteVersion",
    AdminUserCreationWeb = "AdminUserCreationWeb",
    HourBankSync = "HourBankSync",
    QontactPointMonthlyAttendancePdf = "QontactPointMonthlyAttendancePdf",
    PresenteeismRoster = "PresenteeismRoster",
    Presenteeism2FA = "Presenteeism2FA",
    // Gates the "Adopción de la app" screen: who installed the Qontact Auth app,
    // with bulk WhatsApp install invitations. Rolls out per organization.
    AppAdoptionWeb = "AppAdoptionWeb",
}


export type Flags = {
    [key in OldFeatureFlag]?: boolean;
}

export type NewFlags = {
    [key in FeatureFlag]?: boolean;
}

export interface Organization {
    id: string;
    image: string;
    level: string;
    name: string;
    timezone: string;
    /** ISO country (AR, BR, …); drives the language platform notices are shown in. */
    countryCode?: string;
    flags?: Flags;
    newFlags?: NewFlags;
}
